import Swiper, { Pagination } from 'swiper';
import 'swiper/css/bundle';

const initSlider = (selector) => {

    if (!selector) return;

    new Swiper(selector, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: selector.querySelector('.custom-swiper-pagination'),
            bulletClass: 'custom-swiper-pagination__bullet',
            clickable: true,
        },
    });
}

export const initSoundbiteSlider = () => {
    const sliders = document.querySelectorAll( '.js-soundbite-slider' );
    sliders.forEach(slider => initSlider(slider));
}